import Box from "@cloudscape-design/components/box"

/**
 * Renders a field value as plain, legible body text for read-only editor views (#709).
 *
 * When the editor is read-only (vendors, and any `canEdit={false}` context) fields were previously
 * shown inside _disabled_ form controls — gray text on a gray background that reviewers found very
 * hard to read. This renders the value as ordinary dark body text instead. An empty value renders
 * as an em dash so the field still reads as "present but blank" rather than looking broken.
 *
 * For Selects, pass the selected label; for checkboxes, pass "Yes"/"No"; for dates, pass the value.
 */
export const ReadOnlyValue: React.FC<{ value?: string | number | null }> = ({ value }) => {
  const text = value === null || value === undefined ? "" : String(value).trim()
  return text ? (
    <Box padding={{ vertical: "xxs" }}>{text}</Box>
  ) : (
    <Box color="text-status-inactive" padding={{ vertical: "xxs" }}>
      —
    </Box>
  )
}
